import { Link } from 'react-router-dom'
import { useDiagrams } from '../api/queries'
import { DiagramList } from '../pages/DiagramsPage'
import { Card } from './ui'

/** Sagens diagrammer (beslutning 150). Vises kun for Projektleder og opefter. */
export function ProjectDiagramsCard({ projectId }: { projectId: number }) {
  const { data } = useDiagrams(projectId)

  return (
    <Card
      title={`📐 Diagrammer (${data?.length ?? 0})`}
      actions={<Link className="btn btn--sm" to={`/diagrams?projectId=${projectId}`}>+ Ny tegning</Link>}
    >
      {data && data.length > 0 ? (
        <DiagramList diagrams={data} />
      ) : (
        <p className="small muted" style={{ margin: 0 }}>Ingen diagrammer på sagen endnu.</p>
      )}
    </Card>
  )
}
